import axios from "axios";
import constants from "./constants";

export function defaultGet(apiName, success, failure, isCustom) {
    var fullMethodUrl = (isCustom ? constants.baseApiUrl : constants.ctsApiUrl) + apiName;

    axios.get(fullMethodUrl, { headers: constants.headers })
        .then((res) => success(res))
        .catch((err) => failure(err));
}

export function defaultPost(apiName, body, success, failure, isCustom) {
    var fullMethodUrl = (isCustom ? constants.baseApiUrl : constants.ctsApiUrl) + apiName;

    axios.post(fullMethodUrl, body, { headers: constants.headers })
        .then((res) => success(res))
        .catch((err) => failure(err));
}

export function CapitalizeFirstLetter(str) {
    if (str == null || str == undefined || str == "")
        return ""

    try {
        const words = str.trim().split(" ");
        var retVal = words[0][0] +' '+ words[words.length - 1][0];
        return retVal.toUpperCase();
    }
    catch (err) { console.log(err) }
}

export function alertMessage(message) {
    alert(message)
}

export function copyToClipboard(text, messageKey) {
    navigator.clipboard.writeText(text);
    window.showAlert(messageKey, 'success');
}

export function DownloadFile(getRequestUrl, fileName) 
{
    window.showLoading()

    var req = new XMLHttpRequest();
    req.open("GET", getRequestUrl, true);
    req.setRequestHeader("Authorization", 'Bearer ' + sessionStorage.getItem('jwt_token'));
    req.responseType = "blob";
    req.onload = function () 
    {
        if (this.status === 204) 
        {
            var strURL = getRequestUrl.toString();
            if (strURL.toLowerCase().includes("with"))
                window.showAlert("res_Msgs_ThereIsNoAttachment", "warning")
            else 
                window.showAlert("res_Msgs_UnableToDownload", "warning")
            window.hideLoading()
            return
        }

        if (this.status === 500) 
        {
            window.hideLoading()
            window.showAlert("res_Msgs_UnableToDownload", "warning")
            return
        }

        var blob = new Blob([req.response], { type: "application/octetstream" });

        var isIE = false || !!document.documentMode;
        if (isIE) 
        {
            window.navigator.msSaveBlob(blob, fileName);
        }
        else 
        {
            var url = window.URL || window.webkitURL;
            var link = url.createObjectURL(blob);
            var a = document.createElement("a");
            a.setAttribute("download", fileName);
            a.setAttribute("href", link);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }

        window.showAlert('res_Msgs_AttachmentDownloaded', 'success')
        window.hideLoading()
    };
    req.send();
}

export function DownloadFilePost(postRequestUrl, fileName,params) {
    var req = new XMLHttpRequest();
    req.open("POST", postRequestUrl, true);
    req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    req.responseType = "blob";
    let urlEncodedData = "", urlEncodedDataPairs = [], name;
    for( name in params ) {
    urlEncodedDataPairs.push(encodeURIComponent(name)+'='+encodeURIComponent(params[name]));
    }
    req.onload = function () {
        if (this.status === 204) {
            var strURL = postRequestUrl.toString();
            if (strURL.toLowerCase().includes("with")) {
                window.showAlert("res_Msgs_ThereIsNoAttachment", "warning")
            }
            else {
                window.showAlert("res_Msgs_UnableToDownload", "warning")
            }
            return
        }

        if (this.status === 500) {
            window.showAlert("res_Msgs_UnableToDownload", "warning")
            return
        }

        //Convert the Byte Data to BLOB object.
        var blob = new Blob([req.response], { type: "application/octetstream" });
        //Check the Browser type and download the File.

        var isIE = false || !!document.documentMode;
        if (isIE) {
            window.navigator.msSaveBlob(blob, fileName);
        }
        else {
            var url = window.URL || window.webkitURL;
            var link = url.createObjectURL(blob);
            var a = document.createElement("a");
            a.setAttribute("download", fileName);
            a.setAttribute("href", link);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }

        window.showAlert('res_Msgs_AttachmentDownloaded', 'success')
    };
    req.send(urlEncodedDataPairs);
}

export function PrintFile(getRequestUrl, fileName) {
    var req = new XMLHttpRequest();
    req.open("GET", getRequestUrl, true);
    req.setRequestHeader("Authorization", 'Bearer ' + sessionStorage.getItem('jwt_token'));
    req.responseType = "blob";
    req.onload = function () {
        if (this.status === 204) {
            var strURL = getRequestUrl.toString();
            if (strURL.includes("with")) {
                window.showAlert("There is no letter/attachment for the selected correspondence", "warning")
            }
            else {
                window.showAlert("Unable to print for the selected correspondence", "warning")
            }

            return
        }

        var blob = new Blob([req.response], { type: "application/pdf" });
        var blobURL = URL.createObjectURL(blob);

        var iframe = document.createElement('iframe'); //load content in an iframe to print later
        document.body.appendChild(iframe);

        iframe.style.display = 'none';
        iframe.src = blobURL;
        iframe.onload = function () {
            setTimeout(function () {
                iframe.focus();
                iframe.contentWindow.print();
            }, 1);
        };
    };
    req.send();
}

export function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function CheckIfNullOrEmpty(value) {
    if (value == null || value == undefined || value == {} || value == "" || value == "null")
        return true;
    else
        return false;
}

// shortens a grid cell value and appends "..." when it is longer than length.
// pair it with v-tooltip so the full text is still reachable on hover.
export function trimText(text, length) {
    if (text == null)
        return '';

    if (text.length > length)
        return text.substring(0, length) + '...';

    return text;
}

export function  validateEmail(email) {
    if (email.trim() === "")
        return false;

    if (!email.includes('@'))
        return false;

    if (email.includes('@@'))
        return false;

    if (/\s/.test(email))
        return false;

    const [localPart, domainPart] = email.split('@');

    if (!localPart || localPart.startsWith('.') || localPart.endsWith('.'))
        return false;

    if (!domainPart || domainPart.startsWith('.') || domainPart.endsWith('.'))
        return false;

    if (!domainPart.includes('.'))
        return false;

    const domainRegex = /^(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)\.)*(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9]))\.([a-zA-Z]{2,})$/;

    const ipRegex = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])$/;

    if (domainRegex.test(domainPart) || ipRegex.test(domainPart))
        return true;
    else
        return false;

}

export function GetMultiSelectSubHeaderDisplay(options) {
    var retVal = '';
    if (options.isUser) {
        retVal = options.profession + ' - ' + (options.parentName ? options.parentName : '') + ' ( ' + (options.companyName ? options.companyName : '') + ' )'
    }
    else {
        if (options.parentName != null && options.companyName != null)
            retVal = options.parentName + ' ( ' + options.companyName + ' )'
    }

    return retVal;
}

export function GetDateOnly(strDateTime) {
    if (strDateTime == null || strDateTime == undefined || strDateTime == "")
        return ""

    var date = new Date(strDateTime)
    var day = date.getDate()
    var month = date.getMonth() + 1
    var year = date.getFullYear()

    // convert month to 2 digits
    if (month < 10)
        month = '0' + month

    return year + '-' + month + '-' + day
}

export function formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

const overDueStatus = {
    emtpyStatus: 1,
    today: 2,
    nearDue: 3,
    overDue: 4
};

export function getOverDueByNode(overdue, nodeId) {
    var overDueByNode = overDueStatus.emtpyStatus;

    if (overdue == '' || nodeId == 1 || nodeId == 8) {
        overDueByNode = overDueStatus.emtpyStatus;
    }
    else {
        if (overdue == "today")
            overDueByNode = overDueStatus.today
        else if (overdue == "overdue")
            overDueByNode = overDueStatus.overDue
        else if (overdue == "neardue")
            overDueByNode = overDueStatus.nearDue
    }

    return overDueByNode;
}
export function getOverDue(overdue, nodeId) {
    var overDueIcon = ''
    var overDueByNode = this.getOverDueByNode(overdue, nodeId);

    switch (overDueByNode) {
        case overDueStatus.emtpyStatus: overDueIcon = ''; break;
        case overDueStatus.today: overDueIcon = 'mdi-clock'; break;
        case overDueStatus.nearDue: overDueIcon = 'mdi-clock'; break;
        case overDueStatus.overDue: overDueIcon = 'mdi-overdue'; break;
        default: overDueIcon = ''; break;
    }

    return overDueIcon;
}

export function getOverdueDays(overdue, overdueDays, nodeId) {
    var overdueResult = '';
    var overDueByNode = this.getOverDueByNode(overdue, nodeId);

    switch (overDueByNode) {
        case overDueStatus.emtpyStatus: overdueResult = ''; break;
        case overDueStatus.today: overdueResult = window.translate('res_Label_Today'); break;
        case overDueStatus.nearDue:
            overdueResult = Math.abs(parseInt(overdueDays)) == 1 ? + Math.abs(parseInt(overdueDays)) + ' ' + window.translate('res_Label_Day')
                : Math.abs(parseInt(overdueDays)) + ' ' + window.translate('res_Label_Days'); break;
        case overDueStatus.overDue: overdueResult = window.translate('res_Label_Overdue'); break;
        default: overdueResult = ''; break;
    }

    return overdueResult
}

export function getPriorityClassColor(priorityId) {
    switch (priorityId) {
        case 1: return '';
        case 2: return 'text-warning';
        case 3: return 'text-danger';
    }

    return '';
}

export function getPriorityName(id) {
    //console.log(constants.priorities)
    var priority = constants.priorities.find(x => x.id == id);
    if (priority != null) {
        return priority.name
    }
    else {
        return ''
    }
}

export function getPrivacyName(id) {
    var privacy = constants.privacies.find(x => x.id == id)
    if (privacy != null)
        return privacy.name
    else
        return ''
}

export function getStatusClass(id) {
    var status = constants.statuses.find(x => x.id == id)
    if (status != null)
        return status.classColor.toLowerCase().replace(" ", "_")
    else
        return ''
}

export function getStatus(id) {
    var status = constants.statuses.find(x => x.id == id)
    if (status != null)
        return status.name
    else
        return ''
}

export function formatDateTime(datetime) {
    try {
        if (datetime == null || datetime == undefined || datetime == "")
            return ""
        const parts = datetime.replace('T', ' ').split(" ");
        const dateParts = parts[0].split("-");
        const year = dateParts[0].substring(2);
        const month = dateParts[1];
        const day = dateParts[2];
        const formattedDate = `${day}/${month}/${year}`;
        return formattedDate;
    }
    catch (e) {
        return datetime;
    }
}

export function formatDateTimeWithTime(datetime) {
    try 
    {
        if (datetime == null || datetime == undefined || datetime == "")
            return ""

        const [datePart, timePart] = datetime.split("T");
        const [hours, minutes] = timePart.split(":");

        const dateParts = datePart.split("-");
        const formattedDate = dateParts[2] + '/' +  dateParts[1] + '/' + dateParts[0].substring(2) + ' ' 
            + hours + ':' + minutes ;

        return formattedDate;
    }
    catch (e) {
        return datetime;
    }
}

export function formatDateTimeWithExtendedTime(datetime) 
{
    try 
    {
        if (datetime == null || datetime == undefined || datetime == "")
            return ""

        const [datePart, timePart] = datetime.split("T");
        const [hours, minutes, seconds] = timePart.split(":");

        const dateParts = datePart.split("-");
        const formattedDate = dateParts[2] + '/' +  dateParts[1] + '/' + dateParts[0].substring(2) + ' ' + hours + ':' + minutes + ':' + seconds;
        return formattedDate;
    }
    catch (e) 
    {
        return datetime;
    }
}

export function dateFormat(inputDate, format, includeTime) 
{
    if (inputDate == null || inputDate == undefined || inputDate == "")
    {
        return ""
    }

    if (!format) 
        format = 'dd/MM/yyyy'
    
    if (includeTime)
        format = format + " hh:mm:ss"

    if (inputDate != null && inputDate != undefined && inputDate != '') 
    {
        const date = new Date(inputDate);

        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        format = format.replace("MM", month.toString().padStart(2, "0"));

        if (format.indexOf("yyyy") > -1) {
            format = format.replace("yyyy", year.toString());
        } else if (format.indexOf("yy") > -1) {
            format = format.replace("yy", year.toString().substr(2, 2));
        }

        format = format.replace("dd", day.toString().padStart(2, "0"));

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        if (format.indexOf("hh") > -1) {
            format = format.replace("hh", hours.toString());
        }
        if (format.indexOf("mm") > -1) {
            format = format.replace("mm", minutes.toString());
        }
        if (format.indexOf("ss") > -1) {
            format = format.replace("ss", seconds.toString());
        }
        return format;
    }
}

export function formatDateFromString(date) {
    return new Date(date);
}

export const applyDrag = (arr, dragResult) => {
    const { removedIndex, addedIndex, payload } = dragResult
    if (removedIndex === null && addedIndex === null) return arr

    const result = [...arr]
    let itemToAdd = payload

    if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0]
    }

    if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd)
    }

    return result
}

export function GetTranslatedValue(enVal, arVal) {
    var val = enVal;
    if (localStorage.getItem('lang') == 'ar' && arVal) {
        val = arVal
    }

    return val;
}

export function copyObject(sourceObject, targetObject) {
    for (const key in sourceObject) {
        targetObject[key] = sourceObject[key];
    }

    return targetObject;
}

export function ActionsPermission(actionName, document, transferId, delegationId , openedFromNodeId, canSign, userId = 0) 
{    
    var isUserManager = constants.isManager;
    var userHasManager = false
    try 
    {
        var managerId = JSON.parse(sessionStorage.getItem('user')).profile.ManagerId;
        userHasManager = (managerId != null && managerId != undefined && managerId != 0)
    } 
    catch (error) { }

    if (transferId > 0)
        document.isRegistered = true
    else
        document.showVisualTracking = false
    
    if (openedFromNodeId == null || openedFromNodeId == undefined)
        openedFromNodeId = 0
    

    // openedFromNodeId
    // 1: draft, 2: inbox, 6: sent, 8: archive, 9: followup, 7: saved for later , 10: CCed Inbox , 11: advanced search
    var retVal = false  
    var userActionsToolbarMenu = constants.userActions.toolbarMenu
    var signedEnum = constants.statusesEnum.Signed

    switch (actionName) 
    {
        case 'Preview':
            retVal = eval(window.reviewCondition)
            break
        case 'Forward': 
            retVal = eval(window.forwardCondition)
            break
        case 'ForwardCc':
            retVal = eval(window.forwardCcCondition)
            break
        case 'Recall':
            retVal = eval(window.recallCondition)
            break
        case 'ResetDocument':
            retVal = eval(window.editSignedCondition)
            break
        // case 'PartialResetDocument':
        //     retVal = eval(window.partialEditSignedCondition)
        //     break
        case "Approve":
            retVal = [2].indexOf(openedFromNodeId) > -1 && document.purposeId == constants.purposesEnum.ForApproval && document.statusId == 5
                && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.Approve.key)
            break
        case 'PublishToMultiDocument':
            if (document != null && document.receiversAndDesignatedPersons != null) {
                retVal = document.statusId == 5 && document.categoryId == 2 && constants.enableRecipientsMultiDocuments && document.receiversAndDesignatedPersons.length > 1 
                && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.PublishToMultiDocument.key)
                break
            }
            return false
        case 'DispatchCorrespondence':
            retVal = [2].indexOf(openedFromNodeId) > -1 
            && document.statusId == 5 && document.categoryId == 2
            && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.DispatchCorrespondence.key)
            break;
        case 'EmailDispatchCorrespondence':
            retVal = document.hasExternalRecipients == true
            && ActionsPermission('DispatchCorrespondence', document, transferId, delegationId, openedFromNodeId)
            break;
        case 'VisualTracking': 
            retVal =  ([2,6,8,9].indexOf(openedFromNodeId) > -1 || transferId > 0 || document.showVisualTracking)
            && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.VisualTracking.key)
            break
        case 'SigningHistory':
            retVal =  document.categoryId != 1 && document.statusId != 1
            && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.SigningHistory.key)
            break
        case 'Endorse':
            {
                if ((window.enableManagerProperty && isUserManager == true) || userHasManager == false)
                    retVal = false
                else
                {
                    retVal = [0,1,2].indexOf(openedFromNodeId) > -1 && (document.isRegistered && (document.statusId == 1 || (document.cCed == false && document.secretForward != true)))
                    && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.Endorse.key)
                }
            }
            break
        case 'Archive':
            retVal = [1, 2].indexOf(openedFromNodeId) > -1 &&  (document.isRegistered && (document.secretForward != true))
                && constants.userActions.toolbarMenu.some(x => x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.Archive.key)
                && (
                       ([1].indexOf(openedFromNodeId) > -1 &&  (document.referenceSequence != null && document.referenceSequence != '') )||
                       ([2].indexOf(openedFromNodeId) > -1 && document.statusId != 1 &&  ( document.categoryId == 1 || document.statusId == 5  || document.statusId == 4) )
                    )
            break
        case 'UndoArchive':
            retVal = [8].indexOf(openedFromNodeId) > -1;
            break
        case 'SendBack': 
            retVal = [2].indexOf(openedFromNodeId) > -1 && document.isRegistered === true && document.cCed == false && transferId > 0
            && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.SendBack.key)
            break
        case 'Reject':
            retVal =  [2].indexOf(openedFromNodeId) > -1 && document.statusId != 4 && (transferId > 0 && (checkCanSignDocument(document, delegationId, canSign,'reject') || document.purposeId == constants.purposesEnum.ForEndorsement))
            && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.Reject.key)
            break
        case 'DeleteDraft':
            let currentUserId = JSON.parse(sessionStorage.getItem('user')).profile.Id
            let currentStructureId = JSON.parse(sessionStorage.getItem('user')).profile.StructureId

            retVal = document.createdByUserId == currentUserId
                && document.createdByStructureId == currentStructureId && 
            [1,2].indexOf(openedFromNodeId) > -1 && [1,2].includes(document.statusId) && (document.referenceSequence == null || document.referenceSequence == '')
                && constants.userActions.toolbarMenu.some(x => x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.DeleteDraft.key)

                break 
            case 'CancelFollowup':
                retVal = [9].indexOf(openedFromNodeId) > -1 && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.CancelFollowup.key)  
                break
            case 'NotifyEmail':
                var isDocumentSaved = (document.priorityId != null && document.priorityId != undefined);
                retVal = ([6,9].indexOf(openedFromNodeId) > -1) && document.secretForward != true && isDocumentSaved && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.NotifyEmail.key);
                break
            case 'Sign':
                retVal = [0,1,2].indexOf(openedFromNodeId) > -1 && document.statusId != 4 && ( checkCanSignDocument(document, delegationId, canSign,'sign')) 
                break
            case 'SignAndSend':
                retVal = [0,1,2].indexOf(openedFromNodeId) > -1 && document.statusId != 4 && ( checkCanSignDocument(document, delegationId, canSign,'signandsend'))
                break
            case 'Complete':
                const isSigned = document.isSigned == true || document.isSigned == 1;
                retVal = [2].indexOf(openedFromNodeId) > -1 && document.isRegistered && transferId != 0 && ( document.categoryId == 1  || document.statusId == 5 || ( document.secretForward == true && isSigned)) && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.Complete.key)
                break
            case 'CreateOutgoing':
                retVal = [2, 6, 8, 9].indexOf(openedFromNodeId) > -1 && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.CreateOutgoing.key)
                break
            case 'CreateReply':
                retVal = [2, 9].indexOf(openedFromNodeId) > -1 && document.statusId != 4 && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.CreateReply.key)
                break
            case 'ForceGenerateReferenceNumber':
                var isDocumentSaved = (document.priorityId != null && document.priorityId != undefined)
                var doesDocumentHaveReferenceNumber = (document.referenceSequence != null && document.referenceSequence != undefined);
                var isDocumentSigned = (document.statusId == constants.statusesEnum.signed.value);
                retVal = [0,1,2].indexOf(openedFromNodeId) > -1 && isDocumentSaved && !doesDocumentHaveReferenceNumber && !isDocumentSigned && document.categoryId != 1 && constants.userActions.toolbarMenu.some(x => x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.ForceGenerateReferenceNumber.key)
                break
            case 'GenerateDeliveryNote':
                retVal = [2].indexOf(openedFromNodeId) > -1 && document.statusId != 4 &&  document.categoryId == 2 && document.templateId != null && document.templateId != '' && document.secretForward != true && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.GenerateDeliveryNote.key)
                break
            case 'SaveForLater':
                retVal = [2].indexOf(openedFromNodeId) > -1 && document.secretForward != true && window.enableHideLetter == true && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.SaveForLater.key)
                break
            case 'EmailReminder':
                if (window.showReminderByEmail == false)
                    retVal = false
                else
                    retVal = [2].indexOf(openedFromNodeId) > -1 && document.secretForward != true && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.EmailReminder.key)
                break
            case 'ReturnToInbox':
                retVal = [7].indexOf(openedFromNodeId) > -1
                break
            case 'DismissCced':
                retVal = [10,2].indexOf(openedFromNodeId) > -1 && document.cCed == true && window.enableDismissLetter
                break
            case 'DismissSent':
                retVal = [6,66].indexOf(openedFromNodeId) > -1 && document.isDismissedByFrom != true
                break
            case 'ReplaceOriginalMail':
                    retVal = [2].indexOf(openedFromNodeId) > -1 && document.statusId != 4 && document.referenceSequenceType==3 && constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == constants.actionsEnum.toolbarMenu.ReplaceOriginalMail.key)
                    break
            case 'CancelDocument':
                retVal = [2].indexOf(openedFromNodeId) > -1 && document.toUserId == document.createdByUserId && document.purposeId == constants.purposesEnum.Cancel
                break;
            case 'Lock':
            {
                retVal = [2].indexOf(openedFromNodeId) > -1
                break;
            }
            case 'Unlock':
                retVal = [2].indexOf(openedFromNodeId) > -1
                break;
            case 'DisableQRCode':
                retVal = [2].indexOf(openedFromNodeId) > -1 && document.secretForward == false && constants.isFullAdmin && document.isQrCodeEnabled
                break;
        }

    return retVal;
}

export function checkCanSignDocument(document, delegationId, canSign, actionKey) 
{
    if(canSign == "1")
        canSign = true;

    // For Signature, For Action (plus 0/null/undefined = unset)
    var signAllowedPurposes = [constants.purposesEnum.ForSignature, constants.purposesEnum.ForAction, constants.purposesEnum.ForApproval, constants.purposesEnum.ForEndorsement, 0, null, undefined];

    //disable sign on draft
    if (actionKey == 'sign' && (document.transferId == null || document.transferId == undefined || document.transferId == 0))
        return false

    if (delegationId != null && delegationId != undefined && delegationId != 0) {
        var delegation = constants.delegations.find(x => x.id === delegationId)
        if (delegation != null) {
            return delegation.canSign === true && canSign === true &&  IsCced(document) == false &&
                (
                    (signAllowedPurposes.indexOf(document.purposeId) > -1) ||
                    (document.purposeId === constants.purposesEnum.Revoked && signAllowedPurposes.indexOf(document.purposeIdBeforeRevoke) > -1)
                )
        }
    }
    else {
        return canSign === true && IsCced(document) == false && 
            constants.userActions.toolbarMenu.some(x=>x.name.toLowerCase() == actionKey) &&
            (
                (signAllowedPurposes.indexOf(document.purposeId) > -1) ||
                (document.purposeId === constants.purposesEnum.Revoked && document.purposeIdBeforeRevoke != null && signAllowedPurposes.indexOf(document.purposeIdBeforeRevoke) > -1)
            )
    }
}


export function IsCced(document) {
    return document.purposeId == constants.purposesEnum.CCed || document.cCed == true
}

export function SwitchByLang(englishResource = "", arabicResource = "", lang = "") {
    var language = 'ar';
    if (lang.trim() != "" && (lang == 'en' || lang == 'ar'))
        language = lang;
    else if (localStorage.getItem('lang') != null)
        language = localStorage.getItem('lang');

    var isEnglishResourceHasValue = false;
    var isArabicResourceHasValue = false;

    isEnglishResourceHasValue = englishResource !== "" && englishResource !== null && englishResource !== undefined && englishResource.trim() !== '';
    isArabicResourceHasValue = arabicResource !== "" && arabicResource !== null && arabicResource !== undefined && arabicResource.trim() !== '';

    if (language === 'en' && isEnglishResourceHasValue)
        return englishResource;
    else if (language === 'ar' && isArabicResourceHasValue) 
        return arabicResource;
    else if (isEnglishResourceHasValue) 
        return englishResource;
    else if (isArabicResourceHasValue) 
        return arabicResource;
    else
        return "";
}

// Localizes item names to Arabic when the UI language is Arabic.
// NOTE: this previously also injected a hidden placeholder ('temp') as the first
// element of every multiselect list, which was hidden via CSS. That hack is gone.
export function handleFirstElement(data) {
    if (!Array.isArray(data) || data.length == 0)
        return data;

    if (localStorage.getItem('lang') == 'ar') {
        data.forEach(item => {
            if (item == null)
                return;

            var shouldLocalize = (item.added == undefined && item.isUser == undefined)
                || item.isCompany === true;

            if (shouldLocalize && item.nameAr != undefined)
                item.name = item.nameAr;
        });
    }

    return data;
}

export function isArabicText(text){
    var arregex = /[\u0600-\u06FF]/;
    return arregex.test(text);
}

export function validateTowDate(startDate,endDate)
{
    
var res = new Date(endDate) - new Date(startDate);
if(res >= 0)
return true;
return false;
}

export function isNullOrEmpty(val)
{
    if (val == null || val == undefined || val == "")
        return true;

    return false;
}

export function isValidEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}
export function escapeHTML(input) 
{
    const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };

    return String(input).replace(/[&<>"']/g, function(match) {
        return map[match];
    });
}

export function describeCorrespondence(item)
{
    let parts = [];

    if (item.subject)
        parts.push('<strong>' + escapeHTML(window.translate('res_Label_Subject')) + ':</strong> ' + escapeHTML(item.subject));

    if (item.referenceNumber)
        parts.push('<strong>' + escapeHTML(window.translate('res_MenuItems_ReferenceNumber')) + ':</strong> ' + escapeHTML(item.referenceNumber));

    return parts.join('<br>');
}
